import React, { Component } from 'react'
import Grid from '../../../components/grid';
import { format, subDays } from 'date-fns';
import axios from 'axios';
import BtnCellRenderer from '../../../components/grid/BtnCellRenderer';
import './style.scss'
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import ReportDateRange from '../../../components/reportDateRange';
export class SyncLogsView extends Component {
    constructor(props) {
        super(props);
    }
    state = {
        loading: false,
        rowData: [],
        searchText: "",
        startDate: subDays(new Date(), 1),
        endDate: new Date(),
    };

    frameworkComponents = {
        BtnCellRenderer
    }
    reportPayload = {
        endDate: format(new Date(), "MM/dd/yyyy"),
        startDate: format(subDays(new Date(), 1), "MM/dd/yyyy"),
    };

    searchInput = (e) => {
        this.setState({ searchText: e.target.value });
        this.gridApi.purgeInfiniteCache();
        // this.gridApi.refreshInfiniteCache();
    };

    getSyncLogs = async (params) => {
        if (this.props.changeTab) {
            if (this.props.cronLogId) params.cronLogId = null
        } else {
            if (this.props.cronLogId) params.cronLogId = this.props.cronLogId
        }
        let logs = await axios.get('api/logs/sync-logs', { params }).catch(e => {
            return e
        });
        return logs?.data || {};
    };

    columnDefs = [
        { field: "company", headerName: "Company", filter: 'agTextColumnFilter', sortable: true, resizable: true, flex: 1 },
        { field: "syncName", headerName: "Sync Name", filter: 'agTextColumnFilter', sortable: true, resizable: true, flex: 1 },
        { field: "runType", headerName: "Run Type", filter: 'agTextColumnFilter', sortable: true, resizable: true, flex: 1 },
        { field: "createdAt", headerName: "Ran At", filter: false, sortable: true, resizable: true, flex: 1 },
        { headerName: "Status", field: "status", filter: 'agTextColumnFilter', sortable: true, resizable: true, flex: 1 },
        { headerName: "Message", field: "message", filter: false, sortable: true, resizable: true, flex: 1 },
        { field: "cronLogId", headerName: "Cron Job", filter: false, sortable: true, resizable: true, flex: 1 },
    ];
    onGridReady = async (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        let dataSource = {
            getRows: async (params) => {

                this.reportPayload.startRow = params.startRow;
                this.reportPayload.endRow = params.endRow;
                this.reportPayload.sortColumn = params.sortModel[0] && params.sortModel[0].colId || "createdAt";
                this.reportPayload.sortType = params.sortModel[0] && params.sortModel[0].sort || 'desc';
                this.reportPayload.searchText = this.state.searchText;
                this.gridApi.showLoadingOverlay();
                let logsReport = await this.getSyncLogs(this.reportPayload);
                this.gridApi.hideOverlay();
                if (!logsReport.records.length) {
                    this.gridApi.showNoRowsOverlay();
                }
                return params.successCallback(logsReport.records, logsReport.count);
            }
        }

        params.api.setDatasource(dataSource)

    }

    componentDidMount = async () => {


    }


    handleDateRange = (start, end) => {
        this.setState({ startDate: start, endDate: end });
        if (end && this.gridApi) {
            this.reportPayload.startDate = format(new Date(start), "MM/dd/yyyy")
            this.reportPayload.endDate = format(new Date(end), "MM/dd/yyyy")
            this.gridApi.purgeInfiniteCache();
        }
    }

    render() {
        const { loading } = this.state;
        return (
            <div className="logs-view">
                <div className="shadow_white_box full-box mt-0">
                    <div className="filter-list d-flex align-items-center justify-content-between">

                        <div className="filter-field d-flex">
                            <input
                                type="text"
                                placeholder="Search"
                                onChange={(e) => this.searchInput(e)}
                                className="search-input"
                            />
                        </div>
                        <div className="date-range d-flex">
                            <label className="label">Date Range</label>
                            <ReportDateRange
                                mode="range"
                                handleDateRange={this.handleDateRange}
                                startDate={this.state.startDate}
                                endDate={this.state.endDate}
                                applyPadding={true}
                            />
                        </div>
                    </div>
                    <Grid
                        frameworkComponent={this.frameworkComponents}
                        columnDefs={this.columnDefs}
                        onGridReady={this.onGridReady}
                        rowModelType='infinite'
                        height='600px'
                    >
                    </Grid>
                </div>
            </div>
        )
    }
}

export default SyncLogsView;
